if (!customElements.get('ct-product-breadcrumb')) {
 customElements.define('ct-product-breadcrumb', class extends HTMLElement {
  connectedCallback() {
   try {
    if (!document.referrer) return;
    const previous = new URL(document.referrer);
    if (previous.origin !== location.origin) return;
    const collections = JSON.parse(this.querySelector('[data-bc-collections]').textContent);
    const match = collections.find(c => new URL(c.url, location.origin).pathname.replace(/\/$/, '') === previous.pathname.replace(/\/$/, ''));
    if (!match) return;
    const link = this.querySelector('[data-bc-collection]');
    link.textContent = match.title;
    previous.searchParams.delete('preview_theme_id');
    previous.searchParams.delete('view');
    link.href = previous.pathname + previous.search + previous.hash;
    const schema = this.querySelector('[data-ct-breadcrumb-schema]');
    const data = JSON.parse(schema.textContent);
    data.itemListElement[1].name = match.title;
    data.itemListElement[1].item = new URL(match.url, location.origin).href;
    schema.textContent = JSON.stringify(data);
   } catch (_) {}
  }
 });
}